<template>
  <div> 
    <Header/>
    <main class="container-fluid"> 
      <div class='row heading'>
        <div class='col-4 px-3 pt-3 d-none d-md-flex'></div>
        <div class='col-16 px-3 pt-3'>
          <h1 class="title pt-2 mb-0">Programas</h1>
          <h1 class="title"><span  class="pb-2">Acompanhe a timeline dos programas</span></h1> 
        </div>
      </div>
      <section class='row'>

        <div class='col-4 px-3 pb-3'></div>

  <!-- Inicio do filtro-mobile -->
        <b-sidebar 
          ref="sidebarFilter"
          id="sidebar-filter" 
          no-header 
          backdrop-variant="dark" 
          backdrop 
          shadow
          width='220px'
        > 

          <div class='card-header d-flex justify-content-between'>
            <a>Filtro</a>
            <a class="row justify-content-start pointer" @click="closeSidebarFilter" role="button">
              <img src="../../../src/assets/icons/times-circle.svg" class="ico-15"/>
            </a>  
          </div>
    
          <div class='card card-body pt-2 pl-0'>  
            <aside > 
              <ul class="none-p-m">
                <li class='pb-2'>
                  <a v-text="$ml.get('type')" >
                    Tipo
                  </a>
                  <ul class='none-p-m pt-2 pb-3'>
                    <li :class="this.type == '' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="type = '',changeProgram()" v-text="$ml.get('all')" >
                        Todos
                      </a>
                    </li>
                    <li :class="this.type == 'vdp' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="type = 'vdp',changeProgram()"  >
                        VDP
                      </a>
                    </li>
                    <li :class="this.type == 'public' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="type = 'public',changeProgram()" v-text="$ml.get('public')">
                        Públicos
                      </a>
                    </li>
              
                  </ul>
                </li>
      
                <li class='pb-2'>
                  <a v-text="$ml.get('time')">
                    Tempo
                  </a>
                  <ul class='none-p-m pt-2 pb-3'>
                    <li :class="this.period == '' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="period = '',changeProgram()" v-text="$ml.get('all')">
                        Todos
                      </a>
                    </li>
                    <li :class="this.period == 'last_day' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="period = 'last_day',changeProgram()" v-text="$ml.get('oneDayAgo')">
                        há um dia
                      </a>
                    </li>
                    <li :class="this.period == 'last_week' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="period = 'last_week',changeProgram()" v-text="$ml.get('thisWeek')">
                        nesta semana
                      </a>
                    </li>
                    <li :class="this.period == 'last_month' ? 'active py-1' :'py-1'">
                      <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                      <a @click="period = 'last_month',changeProgram()" v-text="$ml.get('lessThanMonthAgo')">
                        há menos de um mês
                      </a>
                    </li>
                  </ul>
                </li> 
              </ul>
            </aside>
          </div>
            
        </b-sidebar>

        <a id="btn-float-mobile" class="d-md-none btn" v-b-toggle.sidebar-filter role="button">
          <svg width="20" height="20" class="mb-1" >       
            <image xlink:href="../../../src/assets/icons/search.svg" width="20" height="20"/>    
          </svg> 
        </a>  
  <!-- Fim -->

        <div class='col-4 pb-3 d-none d-md-flex'>
          <aside class='col'> 
            <ul class="none-p-m">
              <li class='pb-2'>
                <a v-text="$ml.get('type')" >
                  Tipo
                </a>
                <ul class='none-p-m pt-2 pb-3'>
                  <li :class="this.type == '' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="type = '',changeProgram()" v-text="$ml.get('all')">
                      Todos
                    </a>
                  </li>
                  <li :class="this.type == 'vdp' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="type = 'vdp',changeProgram()" >
                      VDP
                    </a>
                  </li>
                  <li :class="this.type == 'public' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="type = 'public',changeProgram()" v-text="$ml.get('public')">
                      Públicos
                    </a>
                  </li>
            
                </ul>
              </li>
         
              <li class='pb-2'>
                <a v-text="$ml.get('time')">
                  Tempo
                </a>
                <ul class='none-p-m pt-2 pb-3'>
                  <li :class="this.period == '' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="period = '',changeProgram()" v-text="$ml.get('all')">
                      Todos
                    </a>
                  </li>
                  <li :class="this.period == 'last_day' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="period = 'last_day',changeProgram()" v-text="$ml.get('oneDayAgo')">
                      há um dia
                    </a>
                  </li>
                  <li :class="this.period == 'last_week' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="period = 'last_week',changeProgram()" v-text="$ml.get('thisWeek')">
                      nesta semana
                    </a>
                  </li>
                  <li :class="this.period == 'last_month' ? 'active py-1' :'py-1'">
                    <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                    <a @click="period = 'last_month',changeProgram()" v-text="$ml.get('lessThanMonthAgo')">
                      há menos de um mês
                    </a>
                  </li>
                </ul>
              </li> 
            </ul>
          </aside>
        </div>
 
        <div class='col-24 col-md-12 px-3 pb-3 mb-5'>
          <div class="col-sm-12 my-3">
            <div class="input-group">
              <input class="form-control filterInput"  v-model="txtSearch" :placeholder="$ml.get('search')" aria-label="Search" style="border-right: none;">
              <div class="input-group-append">
                <div class="input-group-text" style="background-color: #FFF">
                  <svg width="20" height="20" class="mt-1" >       
                    <image xlink:href="../../assets/icons/search_s.svg" width="18" height="18"/>    
                  </svg> 
                </div>
              </div>
            </div>
          </div>

          <div class='col d-column'>
            <div class='card mb-3'>
              <div class='card-body'>

                <div class="loading d-flex ">
                  <div v-if="loading" class="c-loader"></div>
                  <h6 v-else v-show="!itensProgram.length" class='p-1' v-text="$ml.get('noProgramAvailable')">Nenhum programa disponível</h6>
                </div>

                <div v-for="(item, index) in itensProgram" :key="index" @click="detailPush(item.slug)" class='d-column flex-row pt-2' >
                  <div :class="'h-profile h-profile-lg d-flex flex-column py-1 align-items-start pointer '+ (index + 1 == itensProgram.length ? 'no' : '') ">
                    <div class='d-flex align-self-start flex-column align-items-start w-100'>
                      <div class='d-flex align-self-start flex-row align-items-start justify-content-start w-100'>
  
                        <object width="62" height="62" class="rounded-circle img-lg" :data="item.avatar" type="image/png">
                          <img width="62" height="62" class="rounded-circle img-lg" src="../../assets/images/default.png" alt="Avatar">
                        </object>
                        
                        <div class='d-flex ml-2 w-100'>
                          <div class='align-self-start mt-1 w-100'>
                            <h3><a class='link-block'><strong v-text="item.name"></strong></a></h3>
                            <p class='d-flex align-items-center'><span class='align-self-center' v-text="$ml.with($utils.formatData(item.createdAt, $ml.get('ln'))).get('publishedDaysAgo')">Submetido há *</span></p>
                            <div class='actions mt-2 d-flex flex-row'>
                              <VueCustomTooltip label="Vulnerability Disclosure Program">
                                <span v-if="item.type == 'vdp'" class='ico ico-locked ico-vdp mr-1' data-toggle='tooltip' data-placement='top' title='Programa Privado'>
                                  VDP
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip :label="$ml.get('ccpProgPubli')">
                                <span v-if="item.type == 'public'" class='ico ico-locked mr-1'>
                                  <img src="../../../src/assets/icons/unlock.svg" class="ico-13"/>
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip :label="$ml.get('managedProgram')">
                                <span v-if="item.managed" class='ico ico-managed'  data-toggle='tooltip' data-placement='top' title='Gerenciado pela BugHunt'>
                                  <img src='../../assets/images/bughunt.svg' />
                                </span>
                              </VueCustomTooltip>
                            </div>
                            <hr />
                            <div class='card-chart-body w-100'> 
                              <div class='row mb-2'>
                                <div class='col-12 border-r-d'>
                                  <span v-text="$ml.get('reports')">Relatórios</span>
                                  <h6><a>{{item.totalReports}}</a></h6>
                                </div>
                                <div class='col-12 pl-3'>
                                  <span v-text="$ml.get('scope')">Escopo</span>
                                  <h6>{{item.totalScopes}}</h6>
                                </div> 
                              </div> 
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div> 
                  </div> 
                </div> 
  
              </div> 
              <div v-show="totalPages > 10" class='p-3'> 
                <b-pagination
                  v-model="pageActive"
                  :total-rows="totalPages"
                  :per-page="pageSize" 
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')" 
                  align="right">
                </b-pagination> 
              </div> 
            </div> 
          </div>  
        </div>

      </section>
    </main>
  </div>
</template>

<script> 
import header from "./header";
import ProgramService from "../../services/program.service"; 
 
export default {
  components:{
    Header: header
  },
 
  data() {
    return {
      itensProgram: [],
      pageActive: 1,
      pageSize: 10,
      totalPages: 0,
      reward: '',
      type: '',
      period: '',
      loading: true,
      txtSearch: '',
 
    };
  },

  watch:{  
    pageActive: function () {
      this.changeProgram()
    },
 
    txtSearch: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => { 
        this.changeProgram() 
      }, 1000); 
    }
  },

  mounted(){
    this.changeProgram()
  },
 
  methods: {
    closeSidebarFilter(){
      this.$refs.sidebarFilter.hide(); 
    },
 
    detailPush(id) {
      this.$router.push(`/${id}`)
    },

    changeProgram() {
      this.closeSidebarFilter();
      this.itensProgram = [];
      this.loading = true;
      ProgramService.getProgramListVdp(this.pageActive,10,this.txtSearch,this.type,this.period).then(
        (response) => {
          this.loading = false;
          this.itensProgram = response.data.items;  
          this.totalPages =  response.data.total; 
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style scoped> 
.active{
  color: #E10E71 !important; 
}
.active > a{ 
  font-weight: 500;
}
a{
  cursor: pointer;
}
a:active{
  color: #E10E71 !important;
}
 
hr {
  margin-top: .9rem;
  margin-bottom: .9rem;
}
</style>
 